import React from 'react';

import { sendErrorMessageMetricToServer } from './core/services/metrics.js';

export type ClientErrorBoundaryProps = {
  children: React.ReactNode;
};

export class ClientErrorBoundary extends React.Component<ClientErrorBoundaryProps> {
  override componentDidCatch(error: Error) {
    void sendErrorMessageMetricToServer(error.message);
  }

  override render() {
    return this.props.children;
  }
}
